import React from 'react';
import { NextPage } from 'next';

import { getRetailPoint, IRetailPoint } from '~/src/api/content/retail-point';
import Layout from '~/src/features/_layout';
import Contact from '~/src/features/contact';
import { REDESIGN_CONTACT } from '~/src/features/contact/constants/abnVariants';
import ContactOld from '~/src/features/service/Contact';
import { getABNVariantOnSSr } from '~/src/helpers/abn-tests';
import { initialProps } from '~/src/helpers/basePageFunc';
import { getCurrentCity, selectCompanyName } from '~/src/store/selectors/city';

interface IProps {
    contacts: IRetailPoint[],
    companyName: string,
    cityIn: string,
    isRedesignContactAbTestActive?: boolean,
}

const ContactPage: NextPage<IProps> = ({ contacts, companyName, cityIn, isRedesignContactAbTestActive }) => {
    return (
        <Layout
            title={`Контакты: офисы и точки обслуживания провайдера ${companyName} в ${cityIn}`}
            description={`Офисы продаж и обслуживания клиентов интернет-провайдера ${companyName}: карта, адрес, контактная информация. Быстро найти офис ${companyName} в ${cityIn}`}
            withMenu
            withFooter
            withChat
        >
            {isRedesignContactAbTestActive ? <Contact contacts={contacts} /> : <ContactOld contacts={contacts} />}
        </Layout>
    );
};

ContactPage.getInitialProps = async(options) => {
    await initialProps(options);
    const { req } = options;

    const state = options.store.getState();
    const { providerId } = state.city.provider;
    const { cityIn } = getCurrentCity(state);
    const companyName = selectCompanyName(state);

    const resp = await getRetailPoint({ providerId });

    const isRedesignContactAbTestActive = getABNVariantOnSSr(REDESIGN_CONTACT.testName, req) === REDESIGN_CONTACT.variants.on;

    return {
        isRedesignContactAbTestActive,
        contacts: resp.isSuccess ? resp.payload : [],
        companyName,
        cityIn,
    };
};

export default ContactPage;
